import React, { useEffect } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import Wordmark from './Wordmark';

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-brand-bgStart to-brand-bgEnd flex flex-col relative overflow-hidden">
      <div className="noise-overlay"></div>
      
      {/* Subtle top glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-brand-amber/5 blur-[120px] rounded-full pointer-events-none"></div>

      <header className="w-full max-w-5xl mx-auto px-6 py-10 flex justify-between items-center relative z-10">
        <Wordmark className="text-3xl" />
      </header>

      <main className="flex-grow w-full max-w-5xl mx-auto px-6 py-8 relative z-10 flex flex-col">
        <Outlet />
      </main>

      <footer className="w-full max-w-5xl mx-auto px-6 py-16 mt-auto relative z-10 border-t border-white/[0.05]">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          <div className="flex flex-col gap-2">
            <Wordmark className="text-2xl mb-2" />
            <p className="text-brand-dim text-sm">Published by Sussex Endocrine Clinic</p>
            <a 
              href="mailto:sussexendocrineclinic@gmail.com" 
              className="text-brand-muted hover:text-brand-amber transition-colors text-sm"
            >
              sussexendocrineclinic@gmail.com
            </a>
          </div>
          
          <nav className="flex flex-col md:flex-row gap-6 md:gap-8">
            <Link to="/privacy-policy" className="text-brand-muted hover:text-brand-cream transition-colors text-sm">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-brand-muted hover:text-brand-cream transition-colors text-sm">Terms of Use</Link>
            <Link to="/support" className="text-brand-muted hover:text-brand-cream transition-colors text-sm">Support</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}